import { Button, Typography } from '@material-ui/core'
import { Search as SearchIcon } from '@material-ui/icons'
import clsx from 'clsx'

import { Props as CategoryProps, CategorySelector } from './CategorySelector'
import { Props as KeywordProps, PopularKeywords } from './PopularKeywords'
import { Search, Props as SearchProps } from './Search'

interface Props {
  title?: string
  onSearch: () => void
  keywordProps?: KeywordProps
  searchProps: SearchProps
  categoryProps?: CategoryProps
}
export function FilterSearch({ title, onSearch, searchProps, keywordProps, categoryProps }: Props) {
  return (
    <div className={clsx('faq-filter-search', 'faq-filter-search__container')}>
      {title && (
        <Typography variant="h2" className="faq-filter-search__title">
          {title}
        </Typography>
      )}
      <div className={clsx('faq-filter-search__inner')}>
        <Search {...searchProps} />
        {categoryProps && <CategorySelector {...categoryProps} />}
        <Button
          classes={{
            label: 'faq-filter-search-button__label',
            startIcon: 'faq-filter-search-button__icon',
          }}
          variant="contained"
          color="secondary"
          disableElevation
          className={clsx('faq-filter-search__button', 'faq-filter-search-button')}
          startIcon={<SearchIcon />}
          onClick={onSearch}
        >
          検索
        </Button>
      </div>
      {keywordProps && <PopularKeywords {...keywordProps} />}
    </div>
  )
}
